import classNames from 'classnames/bind';
import styles from './InvoiceOpenSalesRep.module.scss';
import TableClassicReport from '../base/TableClassicReport';
import { useEffect, useState } from 'react';
import { IInvoiceOpenSalesRepRecord, IPaginationReport } from '~/utils/interface/report';
import reportApi from '~/apis/report';
import { ColumnType } from '~/utils/types/common';
import dayjs from 'dayjs';

const cx = classNames.bind(styles);

const InvoiceOpenSalesRep = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IInvoiceOpenSalesRepRecord[]>([]);
  const [pagination, setPagination] = useState<IPaginationReport>({
    totalItems: 0,
    totalPage: 0,
    page: 1,
    limit: 10,
    skip: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await reportApi.getInvoiceOpenSalesRep({ page: pagination.page });
        setData(response.data?.data?.responses ?? []);
        setPagination(response.data?.data?.pagination ?? {
          totalItems: 0,
          totalPage: 0,
          page: 1,
          limit: 10,
          skip: 0,
        });
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch invoice open sales rep', error);
        setLoading(false);
      }
    };
    fetchData();
  }, [pagination.page]);


  const columns: Array<ColumnType> = [
    {
      id: "salesRep",
      labelHeader: "Sales Rep",
      renderCell: (invoice: IInvoiceOpenSalesRepRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{invoice.saleRep.name || "-"}</p>
        </div>
      ),
    },
    {
      id: "status",
      labelHeader: "Status",
      renderCell: (invoice: IInvoiceOpenSalesRepRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{invoice.status || "-"}</p>
        </div>
      ),
    },
    {
      id: "number",
      labelHeader: "Number",
      renderCell: (invoice: IInvoiceOpenSalesRepRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{invoice.number || "-"}</p>
        </div>
      ),
    },
    {
      id: "dueDate",
      labelHeader: "Due Date",
      renderCell: (invoice: IInvoiceOpenSalesRepRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{dayjs(invoice.dueDate).format("MM/DD/YYYY") || "-"}</p>
        </div>
      ),
    },
    {
      id: "dateInvoice",
      labelHeader: "Date Invoice",
      renderCell: (invoice: IInvoiceOpenSalesRepRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{dayjs(invoice.dateInvoiced).format("MM/DD/YYYY") || "-"}</p>
        </div>
      ),
    },
    {
      id: "total",
      labelHeader: "Total",
      renderCell: (invoice: IInvoiceOpenSalesRepRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>${invoice.total || "0"}</p>
        </div>
      ),
    },
    {
      id: "totalPaid",
      labelHeader: "Total Paid",
      renderCell: (invoice: IInvoiceOpenSalesRepRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>${invoice.totalPaid || "0"}</p>
        </div>
      ),
    },
    {
      id: "balance",
      labelHeader: "Balance",
      renderCell: (invoice: IInvoiceOpenSalesRepRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>${invoice.balance || "0"}</p>
        </div>
      ),
    },
    {
      id: "relatedRecords",
      labelHeader: "Related Records",
      renderCell: (invoice: IInvoiceOpenSalesRepRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{invoice.relatedContact.name ? `${invoice.relatedContact.name} (Contact)` : "-"}</p>
          <p className={cx("text-content")}>{invoice.jobUniqueCode ? `${invoice.jobUniqueCode} (Job)` : "-"}</p>
        </div>
      ),
    },
  ];

  return (
    <TableClassicReport
      title="Invoice Open Sales Rep"
      columns={columns}
      data={data}
      page={pagination.page}
      totalPages={pagination.totalPage}
      totalItems={pagination.totalItems}
      itemsPerPage={pagination.limit}
      onPageChange={(page) => {
        setPagination({ ...pagination, page });
      }}
      isLoading={loading}
    />
  );
};

export default InvoiceOpenSalesRep;
